import React, { Component } from "react";
import PropTypes from "prop-types";

import { Mutation } from "react-apollo";

import { Fieldset, Field, Control, Button } from "rbx";
import Section from "../Section";
import { CREATE_LOCATION_MUTATION } from "../../graphql/Locations/Locations.graphql";

import { getUTCFormattedDate, ourToast as toast } from "../../utils";
import LocationForm from "./LocationForm";

class AddLocationForm extends Component {
  state = {
    TimeZoneRecIdRef: null,
    LocationID: "",
    LocationName: "",
    Active: true,
    BillToRecIdRef: null,
    Address1: "",
    Address2: "",
    City: "",
    State: "",
    Zip: "",
    Country: "",
    NumberOfLoadingBays: "",
    NumberOfUnloadingBays: "",
    Scales: false,
    LastUsedDate: null,
    SpecialExternalInstructions: "",
    InternalNotes: "",
    PickupLocation: false,
    DeliveryLocation: false
  };

  onChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;

    this.setState({
      [e.target.name]: e.target.name.includes("RecIdRef")
        ? parseInt(value)
        : value
    });
  };

  render() {
    const {
      LocationID,
      LocationName,
      Active,
      BillToRecIdRef,
      Address1,
      Address2,
      City,
      State,
      Zip,
      Country,
      NumberOfLoadingBays,
      NumberOfUnloadingBays,
      Scales,
      LastUsedDate,
      SpecialExternalInstructions,
      InternalNotes,
      TimeZoneRecIdRef,
      PickupLocation,
      DeliveryLocation
    } = this.state;
    const { onComplete } = this.props;
    return (
      <Mutation
        mutation={CREATE_LOCATION_MUTATION}
        refetchQueries={["ALL_LOCATIONS_QUERY"]}
        variables={{
          data: {
            LocationID,
            LocationName,
            Active,
            BillToRecIdRef,
            Address1,
            Address2,
            City,
            State,
            Zip,
            Country,
            NumberOfLoadingBays: parseInt(NumberOfLoadingBays),
            NumberOfUnloadingBays: parseInt(NumberOfUnloadingBays),
            Scales,
            SpecialExternalInstructions,
            InternalNotes,
            PickupLocation,
            DeliveryLocation,
            LastUsedDate: LastUsedDate
              ? getUTCFormattedDate(LastUsedDate)
              : null,
            TimeZoneRecIdRef: parseInt(TimeZoneRecIdRef)
          }
        }}
      >
        {(createLocation, { loading, error }) => (
          <form
            method="POST"
            onSubmit={async e => {
              e.preventDefault();
              try {
                await createLocation();
                onComplete();
                toast.success("Location added successfully.");
              } catch (err) {
                toast.error("Error adding Location.");
              }
            }}
          >
            <Fieldset disabled={loading}>
              <Section title="Add Location">
                <LocationForm
                  inputs={{
                    LocationName,
                    Active,
                    DeliveryLocation,
                    PickupLocation,
                    BillToRecIdRef,
                    Address1,
                    Address2,
                    City,
                    State,
                    Zip,
                    Country,
                    NumberOfLoadingBays,
                    NumberOfUnloadingBays,
                    Scales,
                    LastUsedDate,
                    SpecialExternalInstructions,
                    InternalNotes,
                    TimeZoneRecIdRef
                  }}
                  onChange={this.onChange}
                />
                <hr />
                <Field kind="group">
                  <Control>
                    <Button color="primary" type="submit">
                      Submit
                    </Button>
                  </Control>
                  <Control>
                    <Button type="button" onClick={onComplete}>
                      Cancel
                    </Button>
                  </Control>
                </Field>
              </Section>
            </Fieldset>
          </form>
        )}
      </Mutation>
    );
  }
}

AddLocationForm.propTypes = {
  onComplete: PropTypes.func
};

export default AddLocationForm;
